import './style.scss'

import { ERROR, LOADING, READY, useVisualState } from '../../../hooks/useVisualState'
import React, { useEffect } from 'react'
import { useParams, withRouter } from 'react-router-dom'

import ImageUploader from '../../../components/ImageUploader/ImageUploader'
import { oldGet } from '../../../helpers/requestOld'
import t from '../../../helpers/i18n'

const PlayerPhotoEditor = ({ player_id, player }) => {
  return (
    <div className='hack-player-avatar-editor'>
      <label>
        {player.firstname} {player.lastname}
      </label>
      <ImageUploader
        name='avatar'
        label={t('labels.Avatar')}
        aspect={1}
        finalWidth={180}
        finalHeight={180}
        src={player.avatar}
      />
    </div>
  )
}

const OldPlayersView = () => {
  const [[playersState, players], setPlayers] = useVisualState()
  const { teamId } = useParams()

  useEffect(() => {
    setPlayers(LOADING)
    oldGet('/teams/' + teamId + '/players')
      .then((response) => {
        setPlayers(READY, response)
      })
      .catch((error) => {
        setPlayers(ERROR, error)
      })
  }, [teamId, setPlayers])

  return (
    <div>
      {playersState === READY &&
        Object.keys(players).map((player_id) => {
          const player = players[player_id]
          return (
            <PlayerPhotoEditor
              key={player_id}
              player_id={player_id}
              player={player}
            />
          )
        })}
      {playersState === ERROR && <div>Error: {players.code}</div>}
    </div>
  )
}

export default withRouter(OldPlayersView)
